import { ReactNode } from 'react'
import styles from '../styles/widget.module.css'
import Close from '../assets/icons/Close'
import { useClickOutside } from '../hooks/useClickOutside'

type SimplePopupType = {
  children?: ReactNode,
  isOpen?: boolean
  onClosePopup?: () => void
  className?: string
}

const SimplePopup = ({
  children,
  isOpen = false,
  onClosePopup,
  className = ''
}: SimplePopupType) => {
  const wrapperRef = useClickOutside<HTMLDivElement>(() => {
    onClosePopup?.();
  }, { enabled: isOpen });

  if (!isOpen) return

  return (
    <div ref={wrapperRef} className={`${styles.popupContentWrapper} ${className}`}>
      <div className={styles.popupContentInner}>
        <button className={styles.popupCloseButton} onClick={onClosePopup}><Close /></button>
        <div className={styles.popupContent}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default SimplePopup